import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { Images } from '@constants/images';
import { Subscription } from 'rxjs';
import { MenuFacade } from '@redux/menu.facade';
import { Router } from '@angular/router';
import { AuthService } from '@services/auth/auth.service';
import { User } from '@models/user';
import {toNumbers} from "@angular/compiler-cli/src/version_helpers";
declare var $: any;

declare interface SubRouteInfo {
  path: string;
  title: string;
}

declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
  rol: number[];
  open: boolean;
  submenu: SubRouteInfo[];
}
export const ROUTES: RouteInfo[] = [
  { path: '/admin/home', title: 'menu.home',  icon: Images.iconLiveHomeBlue, class: '', rol: [1], open: false, submenu: [] },
  { path: '/admin/account', title: 'menu.account',  icon: Images.iconLiveBlue, class: '', rol: [1], open: false, submenu: [] },
  { path: '/admin/live', title: 'menu.live',  icon: Images.iconLiveBlue, class: '', rol: [4], open: false, submenu: [] }
  // { path: '/admin/offer', title: 'menu.offer',  icon: Images.iconLiveOfferBlue, class: '', rol: 1, open: false, submenu: [] },
  /* { path: '/admin/marketData', title: 'menu.marketData',  icon: Images.iconMarketData, class: '', rol: 1, open: false, submenu: [
      { path: '/admin/marketData/sell-out', title: 'menu.sellOut' },
      { path: '/admin/marketData/inventory', title: 'menu.inventory' },
      { path: '/admin/marketData/prices', title: 'menu.prices' },
      { path: '/admin/marketData/flooring', title: 'menu.flooring' }
    ] }, */

];


@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, OnDestroy {

  public menuItems: any[] = [];
  public menuLarge = false;
  public menuPermanent = false;

  // @ts-ignore
  public unsubscribeMenu: Subscription;
  public userEmail: string;
  public userRole: string;
  public user: User | null = null;
  public arrowBottom = Images.iconArrowBottom;

  constructor(
    private element: ElementRef,
    private router: Router,
    public authService: AuthService,
    public menuFacade: MenuFacade,
    public images: Images
  ) {
    const self = this;
    self.unsubscribeMenu = self.menuFacade.menuState$.subscribe(
      ok => {
        self.menuLarge = ok.open;
        self.menuPermanent = ok.permanent;
        $('.sidebar').removeClass(!self.menuLarge ? 'menu-large' : 'menu-short');
        $('.sidebar').addClass(self.menuLarge ? 'menu-large' : 'menu-short');
        $('.main-panel').removeClass(!self.menuLarge ? 'menu-large' : 'menu-short');
        $('.main-panel').addClass(self.menuLarge ? 'menu-large' : 'menu-short');
      }
    );
    this.userEmail = sessionStorage.getItem('email') || '';
    this.userRole = sessionStorage.getItem('role') || '0';
  }

  // tslint:disable-next-line:typedef
  ngOnInit() {
    this.menuItems = ROUTES.filter(menuItem => menuItem.rol.includes(Number(this.userRole)));
  }

  // tslint:disable-next-line:typedef
  ngOnDestroy() {
    const self = this;
    self.unsubscribeMenu.unsubscribe();
  }

  public isMobileMenu = () => {
    return $(window).width() <= 991;
  }

  public openSubmenu = (menuItem: RouteInfo) => {
    this.menuItems.map((value) => {
      if (value.path === menuItem.path) {
        menuItem.open = !menuItem.open;
      } else {
        value.open = false;
      }
    });
  }

  public changePermanent = (permanent: boolean) => {
    this.menuFacade.setPermanent(permanent);
  }

  public closeMenu = () => {
    this.menuFacade.setOpen(false);
  }

  public logout = () => {
    this.authService.logout();
    this.router.navigate(['/auth']);
  }
}
